import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Wheat, LogOut, LayoutDashboard, ShieldCheck, MapPin, FileText } from "lucide-react";
import { useApp } from "@/context/AppContext";

export const ROLE_LABEL = {
  collector: "जिल्हाधिकारी",
  rdc: "निवासी उपजिल्हाधिकारी (RDC)",
  aro: "सहायक अधिकारी (ARO)",
  sdo: "उपविभागीय अधिकारी (SDO)",
  tehsildar: "तहसीलदार",
  circle: "मंडळ अधिकारी",
  viewer: "सामान्य तहसीलदार (केवळ पाहणे)",
};

export const STATUS = {
  DRAFT: { label: "प्रारूप", cls: "bg-slate-100 text-slate-600" },
  SUBMITTED: { label: "प्राप्त", cls: "bg-blue-100 text-blue-700" },
  UNDER_VERIFICATION: { label: "पडताळणीत", cls: "bg-amber-100 text-amber-800" },
  FORWARDED: { label: "पुढे पाठवले", cls: "bg-purple-100 text-purple-700" },
  APPROVED: { label: "मंजूर", cls: "bg-emerald-100 text-emerald-700" },
  REJECTED: { label: "नामंजूर", cls: "bg-red-100 text-red-700" },
  ISSUED: { label: "निर्गमित", cls: "bg-[#1b5e3f] text-white" },
};

export function jurisdictionText(user) {
  if (!user) return "";
  if (user.role === "collector" || user.role === "rdc") return "संपूर्ण जिल्हा · सांगली";
  if (user.role === "viewer") return "संपूर्ण जिल्हा · सांगली (केवळ पाहणे)";
  if (user.role === "aro") return "संपूर्ण जिल्हा · सांगली (मुलाखत गुणांकन)";
  if (user.role === "sdo") return `उपविभाग: ${user.jurisdiction}`;
  if (user.role === "tehsildar") return `तहसील: ${user.jurisdiction}`;
  if (user.role === "circle") return `मंडळ अधिकारी · तहसील ${user.tehsil || ""}`;
  return "";
}

export default function OfficerShell({ children }) {
  const { user, logout } = useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const doLogout = () => { logout(); navigate("/officer"); };
  const navBtn = (path, label, Icon) => (
    <button onClick={() => navigate(path)}
      className={`flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[13.5px] font-medium transition-colors ${location.pathname === path ? "bg-white text-[#1b5e3f]" : "text-white/90 hover:bg-white/10"}`}>
      <Icon className="h-4 w-4" /> {label}
    </button>
  );
  return (
    <div className="min-h-screen bg-[#f6f2e6]">
      <header style={{ background: "linear-gradient(120deg,#1b5e3f 0%,#2d7a52 100%)" }} className="text-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-5 py-3.5">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/15 ring-1 ring-white/25"><Wheat className="h-5 w-5" /></span>
            <div>
              <p className="text-[16px] font-bold leading-tight font-latin">ASSK Sangli — अधिकारी पोर्टल</p>
              <p className="text-[12px] text-white/80">{ROLE_LABEL[user?.role] || "अधिकारी"}</p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <span className="flex items-center gap-1.5 rounded-full bg-[#E0A106] px-3.5 py-1.5 text-[12.5px] font-bold text-[#1b3d2a]">
              <MapPin className="h-4 w-4" /> {jurisdictionText(user)}
            </span>
            {navBtn("/officer/dashboard", "डॅशबोर्ड", LayoutDashboard)}
            {["collector", "rdc", "viewer"].includes(user?.role) && navBtn("/officer/applications", "अर्ज", FileText)}
            {user?.role === "collector" && navBtn("/officer/admin", "खाते व्यवस्थापन", ShieldCheck)}
            <button onClick={doLogout} className="flex items-center gap-1.5 rounded-full bg-white/10 px-3.5 py-1.5 text-[13.5px] font-medium text-white hover:bg-white/20">
              <LogOut className="h-4 w-4" /> Logout
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-5 py-6">{children}</main>
    </div>
  );
}
